var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "listCustomerTable",
                attrs: {
                  mode: "remote",
                  title: "Customers",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  selectOptions: {
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: 25,
                    setCurrentPage: _vm.serverParams.setCurrentPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.rows, function(row, key) {
                      return {
                        key: "table-row",
                        fn: function(props) {
                          return [
                            _c("div", { key: key }, [
                              props.column.field == "action"
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "btn edit-btn-vvg waves-effect",
                                          attrs: {
                                            title: "View customer details",
                                            to: {
                                              name: "CustomerView",
                                              params: { id: props.row.id }
                                            }
                                          }
                                        },
                                        [_c("i", { staticClass: "fa fa-eye" })]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "btn edit-btn-vvg waves-effect",
                                          attrs: {
                                            title: "View customer details",
                                            to: {
                                              name: "CustomerView",
                                              params: { id: props.row.id }
                                            }
                                          }
                                        },
                                        [_c("i", { staticClass: "fa fa-eye" })]
                                      )
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    }),
                    {
                      key: "selected-row-actions",
                      fn: function(computed) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(computed.selectedRows) +
                              "\n                        "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              attrs: { title: "Mail" },
                              on: { click: _vm.sendMail }
                            },
                            [_vm._v("Mail")]
                          )
                        ])
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "app-checkbox-good-table-container" }, [
            _c(
              "div",
              { staticClass: "col-6 paddingleft0" },
              [
                _c("vue-good-table", {
                  ref: "smallTable1",
                  attrs: {
                    mode: "remote",
                    title: "Customers",
                    totalRows: _vm.totalRecords,
                    columns: _vm.columns1,
                    rows: _vm.rows1,
                    "select-options": {
                      enabled: true,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: "custom-class",
                      selectionText: "rows selected",
                      clearSelectionText: "clear"
                    },
                    "pagination-options": {
                      enabled: true,
                      mode: "pages",
                      pageLabel: "Page",
                      position: "bottom",
                      perPage: _vm.serverParams1.perPage,
                      setCurrentPage: _vm.serverParams1.setCurrentPage,
                      perPageDropdown: [5, 25, 50, 100, 200, 500],
                      dropdownAllowAll: false
                    },
                    "search-options": {
                      enabled: false
                    }
                  },
                  on: {
                    "on-selected-rows-change": _vm.selectionChanged,
                    "on-page-change": _vm.onPageChange,
                    "on-column-filter": _vm.onColumnFilter,
                    "on-per-page-change": _vm.onPerPageChange,
                    "on-sort-change": _vm.onSortChange
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm._l(_vm.rows, function(row, key) {
                        return {
                          key: "table-row",
                          fn: function(props) {
                            return [
                              _c("div", { key: key }, [
                                props.column.field == "action"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "btn edit-btn-vvg waves-effect",
                                            attrs: {
                                              title: "View customer details",
                                              to: {
                                                name: "CustomerView",
                                                params: { id: props.row.id }
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-eye"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            props.formattedRow[
                                              props.column.field
                                            ]
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                              ])
                            ]
                          }
                        }
                      }),
                      {
                        key: "selected-row-actions",
                        fn: function(computed) {
                          return _c("div", {}, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(computed.selectedRows) +
                                "\n                            "
                            ),
                            _c(
                              "button",
                              {
                                attrs: { title: "Mail" },
                                on: { click: _vm.loadCustomers }
                              },
                              [_vm._v("Mail")]
                            )
                          ])
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Tables With Select")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b74715e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b74715e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tablesSelect.vue
// module id = null
// module chunks = 